module.exports = __webpack_public_path__ + "static/media/rejected-bills.98b013f1.svg";